import React from 'react';

import { AppBar, Box, IconButton, makeStyles, Toolbar, Typography } from '@material-ui/core';
import BackIcon from '@material-ui/icons/ArrowBack';

import GameIcon from 'components/@common/GameIcon/GameIcon';

interface DetailsNavigationBarProps {
  iconUrl: string;
  title: string;
  category: string;
  price?: string;
  payType?: string;

  onBackClick?: () => void;
}

const useStyles = makeStyles(theme => ({
  action: {
    fontSize: 13,
    fontWeight: 'bold',
    padding: 4,
    height: 30,
  },
  payText: {
    fontSize: 10,
    lineHeight: 1.2,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    flexShrink: 1,
  },
  title: {
    lineHeight: 1,
  },
  caption: {
    paddingTop: 2,
    lineHeight: 1,
  },
}));

const DetailsNavigationBar = ({
  iconUrl,
  title,
  category,
  onBackClick,
}: DetailsNavigationBarProps) => {
  const classes = useStyles();

  return (
    <AppBar color="default" elevation={1}>
      <Toolbar variant="dense">
        <Box color="primary.text">
          <IconButton edge="start" aria-label="back" color="inherit" onClick={onBackClick}>
            <BackIcon />
          </IconButton>
        </Box>
        <Box ml={2} display="flex" alignItems="center">
          <GameIcon src={iconUrl} size={32} alt={title} />

          <Box display="flex" flexDirection="column" justifyContent="center">
            <Typography className={classes.title} variant="caption" color="textPrimary">
              <strong>{title}</strong>
            </Typography>
            <Typography className={classes.caption} variant="caption" color="textSecondary">
              {category}
            </Typography>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default DetailsNavigationBar;
